module.exports = __webpack_public_path__ + "static/media/arabi-food.adfa2ec0.png";